import { Component, Input, OnInit, OnDestroy, NgZone } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  Validators,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { AuthenticationService } from '../../../services/auth/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { CommonService } from 'src/app/services/api/common.service';
import { NgxUiLoaderService } from 'ngx-ui-loader'; // Import NgxUiLoaderService
import { MixpanelService } from 'src/app/mixpanel.service';
// declare var myExternalJs: any;
import { SharedService } from 'src/app/services/api/message.service';
import { CommonAnnouncementComponent } from 'src/app/pages/common/common-announcement/common-announcement.component';
import { Subscription } from 'rxjs';
import { DirectivesModule } from 'src/app/directives.module';
import { ToastrService } from 'ngx-toastr';
import { DashboardService } from 'src/app/services/api/consumer/dashboard.service';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { an } from '@fullcalendar/core/internal-common';
import { CompleteProfileChartComponent } from '../complete-profile-chart/complete-profile-chart.component';
import { AvailabilityChartComponent } from '../availability-chart/availability-chart.component';
import { ArticleComponent } from '../../producer/article/article.component';
import { SchoolData } from 'src/app/models/schoolUser';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  standalone: true,
  imports: [
    DirectivesModule,
    FormsModule,
    ReactiveFormsModule,
    CommonAnnouncementComponent,
    CommonModule,
    CarouselModule,
    CompleteProfileChartComponent,
    AvailabilityChartComponent,
    ArticleComponent
  ],
})
export class DashboardComponent implements OnInit, OnDestroy {
  school_count: any;
  email_job_alert_near: any;
  goToProfile() {
    this.router.navigate(['teacher/profile']);
  }
  findNewSchools() {
    this.router.navigate(['teacher/find-new-schools']);
  }
  goTojobs() {
    window.open(`https://jobs-test.classcover.com.au/teacher/jobs`, '_blank');
  }
  goToCalendar() {
    this.router.navigate(['teacher/calendar']);
  }
  date_month: any;
  ngOnDestroy(): void {
    window.removeEventListener('resize', this.updateItemsPerSlide);
  }
  dashboardData: any;
  nonPromotedJobs: any;
  promotedJobs: any;
  paidCourses: any;
  promotion_course: any;
  teacher_fortnight: any;
  upcomingBookings: any;
  availability_health: any;
  teacherProfile: any;
  schoolProps!: SchoolData;
  itemsPerSlide = 3; // Default value

  constructor(
    private router: Router,
    private loginFormFB: FormBuilder,
    private authService: AuthenticationService,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private ngxService: NgxUiLoaderService,
    private mixpanelService: MixpanelService,
    private sharedService: SharedService,
    private toastr: ToastrService,
    private DashboardService: DashboardService,
    private zone: NgZone
  ) { }

  updateItemsPerSlide = () => {
    const width = window.innerWidth;
    this.zone.run(() => {
      if (width < 576) {
        this.itemsPerSlide = 1;
      } else if (width < 992) {
        this.itemsPerSlide = 2;
      } else {
        this.itemsPerSlide = 3;
      }
    });
  };

  // SVG arc path for progress ring
  getProfileProgressArc(percent?: number): string {
    const r = 47;
    const cx = 60;
    const cy = 60;
    // Use argument if provided, else fallback to this.profileCompletion
    const pct =
      percent !== undefined
        ? Math.max(0, Math.min(100, percent))
        : Math.max(0, Math.min(100, this.profileCompletion));
    if (pct === 100) {
      // Full circle: draw two arcs to ensure visibility
      const start = this.polarToCartesian(cx, cy, r, 90);
      const mid = this.polarToCartesian(cx, cy, r, 270);
      return [
        'M',
        start.x,
        start.y,
        'A',
        r,
        r,
        0,
        1,
        1,
        mid.x,
        mid.y,
        'A',
        r,
        r,
        0,
        1,
        1,
        start.x,
        start.y,
      ].join(' ');
    }
    const angle = (pct / 100) * 360;
    // Start at top (12 o'clock)
    const startAngle = 90; // 0 degrees is at 3 o'clock, so -90 starts at 12 o'clock
    const endAngle = startAngle + angle;

    // Convert angles to radians
    const start = this.polarToCartesian(cx, cy, r, startAngle);
    const end = this.polarToCartesian(cx, cy, r, endAngle);

    const largeArcFlag = pct > 50 ? 1 : 0;

    return [
      'M',
      start.x,
      start.y,
      'A',
      r,
      r,
      0,
      largeArcFlag,
      1,
      end.x,
      end.y,
    ].join(' ');
  }

  polarToCartesian(cx: number, cy: number, r: number, angle: number) {
    const rad = ((angle - 90) * Math.PI) / 180.0;
    return {
      x: cx + r * Math.cos(rad),
      y: cy + r * Math.sin(rad),
    };
  }
  profileCompletion = 15; // percent, set to 15 for your example

  getSmallProfileDashOffset(availability_health: number): string {
    const r = 35;
    const circumference = 2 * Math.PI * r;
    var adjustedHealth = 100 - availability_health; // Adjusted to subtract 100
    const percent = Math.max(0, Math.min(100, adjustedHealth));
    const offset = circumference - (circumference * percent) / 100;
    return offset.toFixed(3);
  }

  getSmallProfileDashArray(_availability_health?: number): string {
    const r = 35;
    return (2 * Math.PI * r).toFixed(3);
  }

  getProfileProgressDashOffset(): string {
    // Calculate offset based on profileCompletion, always >= 0
    const percent = Math.max(0, Math.min(100, this.profileCompletion));
    const circumference = parseFloat(
      DashboardComponent.PROFILE_RING_CIRCUMFERENCE
    );
    const offset = circumference - (circumference * percent) / 100 - 100;
    return offset.toFixed(3);
  }
  getProfileProgressDashArray(): string {
    // Return the circumference for the SVG ring
    return DashboardComponent.PROFILE_RING_CIRCUMFERENCE;
  }
  static PROFILE_RING_CIRCUMFERENCE = (2 * Math.PI * 35).toFixed(3); // r=35

  ngOnInit(): void {
    this.updateItemsPerSlide();
    window.addEventListener('resize', this.updateItemsPerSlide);
    this.schoolProps = JSON.parse(localStorage.getItem('userData') || '{}');

    this.ngxService.start();
    this.DashboardService.teachersDashboardAPI().subscribe({
      next: (res: any) => {
        if (res.status) {
          this.dashboardData = res.data;
          this.nonPromotedJobs = res.data.job_list.non_promoted_job;
          this.promotedJobs = res.data.job_list.promoted_job;
          this.paidCourses = res.data.courses.paid_course;
          this.promotion_course = res.data.courses.promotion_course;
          this.teacherProfile = res.data.teacher_profile;
          this.email_job_alert_near = res?.data?.email_job_alert_near;
          this.ngxService.stop();
        } else {
          this.toastr.error(res.message);
          this.ngxService.stop();
        }
      },
      error: (err: any) => {
        this.ngxService.stop();
        console.log(err);
      },
    });
    this.DashboardService.teachersDashboardBookingsAPI().subscribe({
      next: (res: any) => {
        if (res.status) {
          this.availability_health = res.data.availability_health;
          this.upcomingBookings = res.data.upcoming_bookings;
          this.teacher_fortnight = res.data.teacher_fortnight;
          this.date_month = res.data.date_month;
          this.school_count = res.data.school_count;
          this.ngxService.stop();
        } else {
          this.toastr.error(res.message);
          this.ngxService.stop();
        }
      },
      error: (err: any) => {
        this.ngxService.stop();
        console.log(err);
      },
    });
  }
  getLoadDataOnSave() {
    this.ngxService.start();
    this.DashboardService.teachersDashboardAPI().subscribe({
      next: (res: any) => {
        if (res.status) {
          this.nonPromotedJobs = res.data.job_list.non_promoted_job;
          this.promotedJobs = res.data.job_list.promoted_job;
          this.ngxService.stop();
        } else {
          this.toastr.error(res.message);
          this.ngxService.stop();
        }
      },
      error: (err: any) => {
        this.ngxService.stop();
        console.log(err);
      },
    });
  }
  nextClick() {
    // Take first date and add 7 days (date_format is DD/MM/YYYY)
    const arr = this.teacher_fortnight?.availability;
    let date = arr && arr.length > 0 ? arr[0]?.date_format : null;
    let resultDate: string | null = null;
    if (date && typeof date === 'string') {
      const [day, month, year] = date.split('/').map(Number);
      if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
        const d = new Date(year, month - 1, day);
        if (!isNaN(d.getTime())) {
          d.setDate(d.getDate() + 7);
          // Format as DD/MM/YYYY for API
          const dd = String(d.getDate()).padStart(2, '0');
          const mm = String(d.getMonth() + 1).padStart(2, '0');
          const yyyy = d.getFullYear();
          resultDate = `${dd}/${mm}/${yyyy}`;
        }
      }
    }
    this.nextPrev(resultDate);
  }
  prevClick() {
    // Take first date and subtract 7 days (date_format is DD/MM/YYYY)
    const arr = this.teacher_fortnight?.availability;
    let date = arr && arr.length > 0 ? arr[0]?.date_format : null;
    let resultDate: string | null = null;
    if (date && typeof date === 'string') {
      const [day, month, year] = date.split('/').map(Number);
      if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
        const d = new Date(year, month - 1, day);
        if (!isNaN(d.getTime())) {
          d.setDate(d.getDate() - 7);
          // Format as DD/MM/YYYY for API
          const dd = String(d.getDate()).padStart(2, '0');
          const mm = String(d.getMonth() + 1).padStart(2, '0');
          const yyyy = d.getFullYear();
          resultDate = `${dd}/${mm}/${yyyy}`;
        }
      }
    }
    this.nextPrev(resultDate);
  }
  nextPrev(date: string | null) {
    this.ngxService.start();
    this.DashboardService.nextPrevAPI(date).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.teacher_fortnight = res.data;
          this.date_month = res.date_month;
          this.ngxService.stop();
        } else {
          this.toastr.error(res.message);
          this.ngxService.stop();
        }
      },
      error: (err: any) => {
        this.ngxService.stop();
        console.log(err);
      },
    });
  }

  jobSaveUnsaveAPI(jobId: any, action: string): void {
    this.ngxService.start();
    this.DashboardService.jobSaveUnsaveAPI(jobId, action).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.toastr.success(res.message);
          this.getLoadDataOnSave();
          this.ngxService.stop();
        } else {
          this.toastr.error(res.message);
          this.ngxService.stop();
        }
      },
      error: (err: any) => {
        this.ngxService.stop();
        console.log(err);
      },
    });
  }
  getJobAlert(event: any): void {
    // Determine checked state and action
    const checked = (event.target as HTMLInputElement)?.checked;
    const value = checked ? 1 : 0;
    const action = 'job_dashboard';
    // this.ngxService.start();
    this.DashboardService.getJobAlertAPI(value, action).subscribe({
      next: (res: any) => {
        console.log(res);
        if (res.status) {
          this.toastr.success(res.message);
          // this.router.navigate([this.router.url]);
          this.ngxService.stop();
        } else {
          this.toastr.error(res.message);
          this.ngxService.stop();
        }
      },
      error: (err: any) => {
        this.ngxService.stop();
        console.log(err);
      },
    });
  }

  viewDetails(slidelink: any) {
    window.open(slidelink, '_blank');
  }
  handlePageData(data: any) {
    // Store the page data for later use, e.g. pagination or display
    this.pageData = data;
    // Optionally, update the UI or trigger other logic if needed
    // Example: this.obsArray.next(data.consumer_list || []);
  }
  pageData: any;

}
